import React, { useContext, useState } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { PolicyManagementContextStore } from '../../../context/PolicyManagementContext'
import { ActiveInsuranceModel } from '../../../models/insurance-models/ActiveInsuranceModel'
import { PolicyCardSkeleton } from '../PolicyCardSkeleton'
import { PolicyListCard } from '../PolicyListCard'
import {
    BrowserView,
    isMobile,
    isBrowser,
    MobileView,
} from 'react-device-detect'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import FlexView from 'react-flexview/lib'
import { PolicyDetails } from './PolicyDetails'
import { PolicyCOIDetails } from './PolicyCOIDetails/PolicyCOIDetails'
import PolicyCOIExtensionContext from '../../../context/PolicyCOIExtensionContext'
import { SkySwitch } from '../../Core/Switch/SkySwitch'
import { isUK } from '../../../services/utils'
import { ListPolicyCOIView } from './PolicyCOIDetails/ListPolicyCOIView'
import { BackButtonTitle } from '../../Core/BackButtonTitle'

var classNames = require('classnames')

export const Policy = () => {
    const myPoliciesContext = useContext(PolicyManagementContextStore)
    let { insuranceId } = useParams()
    let insurance: ActiveInsuranceModel = myPoliciesContext.all_policies.find(
        (pol: ActiveInsuranceModel) => pol.insuranceId == insuranceId
    )
    const history = useHistory()
    const location = useLocation()
    const [expand, setExpand] = useState(!!location.state.open_details)

    const toggleExpand = () => {
        setExpand(!expand)
    }

    const setExpandTrue = () => setExpand(true)
    const setExpandFalse = () => setExpand(false)

    return myPoliciesContext.loading_policies ? (
        <PolicyCardSkeleton />
    ) : (
        <>
            <PolicyListCard
                buttons={
                    <FlexView className="full-width">
                        {isBrowser && (
                            <>
                                {/* {!isUK() && <div onClick={setExpandFalse} className={classNames("policy-card-item-button card-button-left blue clickable text-body", {'enabled': !expand})}>
                                {insurance.isActiveOrSchedule() ? "Manage Certificates" : "View Certificates"}
                            </div>} */}
                                {/* <div onClick={setExpandTrue} className={classNames("policy-card-item-button card-button-right blue clickable text-body", {'enabled': expand})}>
                                {insurance.isActiveOrSchedule() ? "Manage Policy" : "Policy Details"}
                            </div> */}
                            </>
                        )}
                    </FlexView>
                }
                insurance={insurance}
            />

            {expand && <PolicyDetails />}

           
        </>
    )
}
